import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Compass, PenTool, Code, Rocket } from 'lucide-react';

const icons = [Compass, PenTool, Code, Rocket];
const keys = ['s1', 's2', 's3', 's4'];

const Process = () => {
  const { t } = useTranslation();
  return (
    <section id="process" data-testid="process-section" className="py-14 lg:py-20 bg-[#FAF8F5] relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <motion.div className="absolute whitespace-nowrap" style={{ bottom: '5%' }}
          animate={{ x: ['-20%', '5%'] }} transition={{ duration: 30, repeat: Infinity, ease: 'linear', repeatType: 'reverse' }}>
          <span className="text-[14vw] font-bold text-[#1A1816]/[0.025] tracking-[-0.05em] font-sans leading-none">
            PROCESS&nbsp;&nbsp;&nbsp;STRATEGY&nbsp;&nbsp;&nbsp;PROCESS&nbsp;&nbsp;&nbsp;STRATEGY
          </span>
        </motion.div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div className="mb-16" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[1px] bg-[#C9A96E]" />
            <span className="text-[9px] font-semibold tracking-[0.3em] uppercase text-[#8A857D]">{t('process.label')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-sans font-bold text-[#1A1816]">
            {t('process.title1')} <span className="font-serif italic text-[#C9A96E]">{t('process.title2')}</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          {keys.map((k, i) => {
            const Icon = icons[i];
            return (
              <motion.div key={k} data-testid={`process-step-${i}`}
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-4xl font-serif italic text-[#C9A96E]/30">0{i + 1}</span>
                  <Icon className="w-5 h-5 text-[#C9A96E]" strokeWidth={1.5} />
                </div>
                <h3 className="text-base font-semibold text-[#1A1816] mb-2">{t(`process.${k}`)}</h3>
                <p className="text-sm text-[#8A857D] leading-relaxed">{t(`process.d${i + 1}`)}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
